import { CultureInfo } from '../culture-info.model';
import { CultureInfoSe } from './se';

/**
 * @ignore
 */
export const CultureInfoSeSE: CultureInfo = {
  name: 'se-SE',
  displayName: 'Northern Sami (Sweden)',
  iso3LanguageCode: 'sme',
  iso2LanguageCode: 'se',
  ietfLanguageTag: 'se-SE',
  parent: CultureInfoSe
};
